module.exports = __webpack_public_path__ + "media/images/bbb_logo-2928f1233eba1e3a600dd6591572adfd.png";